import { render, staticRenderFns } from "./TextContributionCaptionCard.vue?vue&type=template&id=3cc6dd0b&scoped=true"
import script from "./TextContributionCaptionCard.vue?vue&type=script&lang=js"
export * from "./TextContributionCaptionCard.vue?vue&type=script&lang=js"
import style0 from "./TextContributionCaptionCard.vue?vue&type=style&index=0&id=3cc6dd0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6dd0b",
  null
  
)

export default component.exports